var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"master-dashboard-layout"},[_c('div',{staticClass:"header-row"},[_vm._t("header")],2),_c('div',{staticClass:"content-row ma-4 mt-0"},[_c('div',{staticClass:"content"},[_vm._t("content")],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }